import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { MessageImpl } from "./message.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(["critical", "neutral"])
};
const defaultProps = {
  tone: "neutral"
};
const Message = ({ children, tone, ...restProps }) => /* @__PURE__ */ jsx(MessageImpl, { ...restProps, $tone: tone, children });
Message.propTypes = propTypes;
Message.defaultProps = defaultProps;
export {
  Message
};
